import React, { Component, Fragment } from "react"
import { Tabs, Tab, Divider, Hidden } from "@material-ui/core"
import { connect } from "react-redux"
import { getCurrentHost } from "../../utils/getHost"
import { isEmpty } from "lodash"

class TabBar extends Component {
  handleChange = (e, value) => {
    const { accessLevel, activeCompany, authenticatedUser } = this.props
    if (accessLevel === 1) {
      if (value === 1) {
        this.props.history.push("/shoots")
        window.location.reload()
      } else if (value === 2) {
        this.props.history.push("/clients")
      } else if (value === 3) {
        this.props.history.push("/billing")
      } else if (value === 4 && activeCompany === 3) {
        this.props.history.push("/roles")
      } else if (value === 5 && activeCompany === 3) {
        this.props.history.push("/gigs")
      } else if (value === 4 && activeCompany !== 3) {
        this.props.history.push("/gigs")
      } else if (value === 3 && activeCompany !== 3) {
        this.props.history.push("/my-billing")
      } else {
        this.props.history.push("/")
      }
    } else {
      if (
        value === 1 &&
        authenticatedUser &&
        authenticatedUser.id &&
        getCurrentHost() === "crewmama"
      ) {
        this.props.history.push("/my-shoots")
      } else if (
        value === 3 &&
        authenticatedUser &&
        authenticatedUser.id &&
        getCurrentHost() === "crewmama"
      ) {
        this.props.history.push("/my-billing")
      } else if (
        value === 2 ||
        ((value === 1 && isEmpty(authenticatedUser)) ||
          (value === 1 && getCurrentHost() !== "crewmama"))
      ) {
        this.props.history.push("/gigs")
      } else {
        this.props.history.push("/")
      }
    }
  }

  render() {
    const { activeCompany, accessLevel, authenticatedUser } = this.props

    let tabValue = 0
    if (this.props.history.location.pathname.includes("shoots")) {
      tabValue = 1
    } else if (this.props.history.location.pathname.includes("clients")) {
      tabValue = 2
    } else if (this.props.history.location.pathname.includes("billing")) {
      tabValue = 3
    } else if (this.props.history.location.pathname.includes("roles")) {
      tabValue = 4
    } else if (
      this.props.history.location.pathname.includes("gigs") &&
      activeCompany === null
    ) {
      tabValue = 2
    } else if (
      this.props.history.location.pathname.includes("gigs") &&
      activeCompany === 2
    ) {
      tabValue = 4
    } else if (
      this.props.history.location.pathname.includes("gigs") &&
      activeCompany === 3
    ) {
      tabValue = 5
    } else if (this.props.history.location.pathname.includes("my-billing")) {
      tabValue = 3
    }
    return (
      <Fragment>
        {/* WEB VIEW */}
        <Hidden smDown>
          <Tabs
            value={tabValue}
            onChange={this.handleChange}
            aria-label="simple tabs example"
            TabIndicatorProps={{
              style: {
                background:
                  getCurrentHost() === "crewmama" ? "#ffffff" : "primary",
              },
            }}
          >
            <Tab label="Crew" />
            {(!activeCompany || accessLevel !== 1) &&
              authenticatedUser &&
              authenticatedUser.id &&
              getCurrentHost() === "crewmama" && <Tab label="My Shoots" />}
            {accessLevel === 1 && <Tab label="Shoots" />}
            {accessLevel === 1 && <Tab label="Clients" />}
            {accessLevel === 1 && <Tab label="Billing" />}
            {activeCompany === 3 && accessLevel === 1 && <Tab label="Roles" />}
            <Tab label="Gigs" />
            {(!activeCompany || accessLevel !== 1) &&
              authenticatedUser &&
              authenticatedUser.id &&
              getCurrentHost() === "crewmama" && <Tab label="My Billing" />}
          </Tabs>
        </Hidden>

        {/* MOBILE VIEW */}
        <Hidden mdUp>
          <Tabs
            value={tabValue}
            onChange={this.handleChange}
            aria-label="simple tabs example"
            TabIndicatorProps={{
              style: {
                background:
                  getCurrentHost() === "crewmama" ? "#ffffff" : "primary",
              },
            }}
            variant="scrollable"
            scrollButtons="auto"
          >
            // variant="fullWidth"
            <Tab label="Crew" />
            {!activeCompany &&
              authenticatedUser &&
              authenticatedUser.id &&
              getCurrentHost() === "crewmama" && <Tab label="My Shoots" />}
            {accessLevel === 1 && <Tab label="Shoots" />}
            {accessLevel === 1 && <Tab label="Clients" />}
            {accessLevel === 1 && <Tab label="Billing" />}
            {activeCompany === 3 && accessLevel === 1 && <Tab label="Roles" />}
            <Tab label="Gigs" />
            {(!activeCompany || accessLevel !== 1) &&
              authenticatedUser &&
              authenticatedUser.id &&
              getCurrentHost() === "crewmama" && <Tab label="My Billing" />}
            {/* <Tab label="My Billing" /> */}
          </Tabs>
        </Hidden>

        {this.props.showDivider && <Divider />}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    authenticatedUser: state.authentication.authenticatedUser,
  }
}

export default connect(mapStateToProps)(TabBar)
